import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';

import FormBloc from "components/form/FormBloc";
import Badge from "components/Badge";

import GlobalMissedRevenue from "./components/GlobalMissedRevenue";
import Loader from "../Loader";

import {greyishBlue700} from "assets/jss/main";

import {getStockAlert} from "api/product/stockAlert";

import useScrollTrigger from "hooks/useScrollTrigger";

StockAlert.propTypes = {
    productId: PropTypes.string
};

function StockAlert({productId}) {
    const [loading, setLoading] = useState(false);
    const [totalMissedRevenue, setTotalMissedRevenue] = useState(0);
    const [variations, setVariations] = useState([]);

    const [sectionRef, triggered] = useScrollTrigger(productId);

    useEffect(() => {
        if (!triggered || !productId) {
            return;
        }

        setLoading(true);
        getStockAlert(productId)
            .then(r => {
                setTotalMissedRevenue(r.total_missed_revenue);
                setVariations(r.variations);
            })
            .finally(() => setLoading(false));
    }, [triggered, productId]);

    if (!productId) {
        return null;
    }

    return (
        <div ref={sectionRef}>
            {(loading || totalMissedRevenue > 0) && (
                <div style={{
                    background: '#FFF',
                    padding: '24px',
                    borderRadius: '8px',
                    boxShadow: '0px 4px 22px 0px rgba(0, 0, 0, 0.04)',
                }}>
                    <FormBloc titleId='product.show.stockAlert.title' rightElement={!loading && <GlobalMissedRevenue revenue={totalMissedRevenue}/> }>
                        {loading && <Loader />}

                        {!loading && (
                            <div style={{
                                display: 'flex',
                                gap: '4px'
                            }}>
                                {variations.map((variation) => (
                                    <Badge
                                        key={variation.variation_id}
                                        color={'draft'}
                                        border
                                        labelColor={greyishBlue700}
                                    >
                                        {variation.color} · {variation.size} · x{variation.alert_count}
                                    </Badge>
                                ))}
                            </div>
                        )}
                    </FormBloc>
                </div>
            )}
        </div>
    );
}

export default StockAlert;
